// Alias
import settings from './settings';

export default settings;



// WEBPACK FOOTER //
// ./~/@salesforce/design-system-react/components/SLDSSettings.js